import './style.css';
import { setupGlobalDelegation, registerAction, registerInputAction } from './utils/eventDelegation';
import { renderHome, setupHomeListener } from './screens/Home';
import { renderLevelSelect, setupLevelSelectListener } from './screens/LevelSelect';
import { NavBar } from './ui/NavBar';
import { renderTextGameEngine, cleanupTextGame } from './engine/TextGameEngine';
import { renderTimerGameEngine, cleanupTimerGame } from './engine/TimerGameEngine';
import { renderEmojiGameEngine, cleanupEmojiGame, setupEmojiGridListener } from './engine/EmojiGameEngine';
import { renderGameSetup } from './screens/GameSetup';
import { renderPremium } from './screens/Premium';
import { renderInvite } from './screens/Invite';
import { renderProfile } from './screens/Profile';
import { renderTournamentSetup, resetSetupState as resetTournamentSetupState } from './screens/TournamentSetup';
import { renderTournamentBoard } from './screens/TournamentBoard';
import { renderTournamentVictory } from './screens/TournamentVictory';
import { tryRestoreActive } from './engine/TournamentEngine';
import { state } from './store';
import { initTelegram, setupBackButton, tapFeedback, requestWakeLock, releaseWakeLock } from './tma';
import './ui/DifficultyButton';
import { api, setToken, loadDifficulty, isTerminal, haltAllRequests } from './api/client';
import { t, ensureI18nLang } from './i18n';
import { cardsManager } from './engine/cardsManager';


initTelegram();
(window as any).__tapFeedback = tapFeedback;

// ─── Event delegation ─────────────────────────────────────────────────
setupGlobalDelegation(document.body);

registerAction('tg-close', () => { (window as any).Telegram?.WebApp?.close(); });
registerAction('nav', (el) => { window.navTo(el.dataset.to!); });
registerAction('nav-premium', () => { window.navTo('premium'); });
registerAction('nav-premium-coins', () => { window.navToPremiumCoins(); });
registerAction('share-invite-home', () => { (window as any).shareInviteFromHome?.(); });
registerAction('close-unlock-popup', () => { document.getElementById('unlock-popup-overlay')?.remove(); });
registerAction('select-game-tab', (el) => { (window as any).selectGameTab?.(el.dataset.game); });
registerAction('cycle-player-emoji', (el) => { (window as any).cyclePlayerEmoji?.(el.dataset.playerId); });
registerAction('remove-player', (el) => { (window as any).removePlayer?.(el.dataset.playerId); });
registerAction('set-difficulty', (el) => { (window as any).__setDifficulty?.(el.dataset.range || null); });
registerAction('add-player', () => { (window as any).addPlayer?.(); });
registerAction('launch-game', () => { (window as any).launchGameFromSetup?.(); });
registerAction('select-premium-option', (el) => { (window as any).selectPremiumOption?.(el); });
registerAction('select-coin-option', (el) => { (window as any).selectCoinOption?.(el); });
registerAction('premium-purchase', () => { (window as any).handlePremiumPurchase?.(); });
registerAction('coins-purchase', () => { (window as any).handleCoinsPurchase?.(); });
registerAction('set-lang', (el) => { (window as any).setLang?.(el.dataset.lang); });
registerAction('close-lang-picker', () => { document.getElementById('lang-picker-overlay')?.remove(); });
registerAction('show-lang-picker', () => { (window as any).showLangPicker?.(); });
registerAction('open-url', (el) => { if (el.dataset.url) window.open(el.dataset.url, '_blank'); });
registerAction('submit-email-form', () => { (window as any).submitEmailForm?.(); });
registerAction('close-email-popup', () => { (window as any).closeEmailPopup?.(); });
registerAction('open-email-popup', () => { (window as any).openEmailPopup?.(); });
registerAction('claim-channel-reward', () => { (window as any).claimChannelReward?.(); });
registerAction('open-channel-link', () => { (window as any).openChannelLink?.(); });
registerAction('close-tg-app', () => { (window as any).closeTgApp?.(); });
registerAction('claim-pm-reward', () => { (window as any).claimPmReward?.(); });
registerAction('claim-pm-task', () => { (window as any).claimPmTask?.(); });
registerAction('share-referral', () => { (window as any).shareReferralTelegram?.(); });
registerAction('copy-referral-link', () => { (window as any).copyReferralLink?.(); });
registerAction('trn-toggle-player', (el) => { (window as any).trnTogglePlayer?.(el.dataset.playerId); });
registerAction('trn-remove-team', (el) => { (window as any).trnRemoveTeam?.(el.dataset.teamId); });
registerAction('trn-cycle-team-emoji', (el) => { (window as any).trnCycleTeamEmoji?.(el.dataset.teamId); });
registerAction('trn-remove-player', (el) => { (window as any).removePlayer?.(el.dataset.playerId); (window as any).trnRenderKeepScroll?.(); });
registerAction('trn-add-player', () => { (window as any).addPlayer?.(); (window as any).trnAutoAssignNewPlayer?.(); (window as any).trnRenderKeepScroll?.(); });
registerAction('trn-undo-round', () => { (window as any).trnUndoRound?.(); });
registerAction('trn-set-score-target', (el) => { (window as any).trnSetScoreTarget?.(Number(el.dataset.value)); });
registerAction('trn-set-turn-timer', (el) => { (window as any).trnSetTurnTimer?.(Number(el.dataset.value)); });
registerAction('trn-toggle-minigame', (el) => { (window as any).trnToggleMinigame?.(el.dataset.id); });
registerAction('trn-toggle-category', (el) => { (window as any).trnToggleCategory?.(el.dataset.id); });
registerAction('trn-set-difficulty', (el) => { (window as any).trnSetDifficulty?.(el.dataset.range || null); });
registerAction('trn-add-team', () => { (window as any).trnAddTeam?.(); });
registerAction('trn-auto-split', () => { (window as any).trnAutoSplit?.(); });
registerAction('trn-toggle-settings', () => { (window as any).trnToggleSettings?.(); });
registerAction('trn-start', () => { (window as any).trnStart?.(); });
registerAction('trn-exit-confirm', () => { (window as any).trnExitConfirm?.(); });
registerAction('trn-roll-dice', () => { (window as any).trnRollDice?.(); });
registerAction('trn-go-home', () => { (window as any).trnGoHome?.(); });
registerAction('trn-rematch', () => { (window as any).trnRematch?.(); });
registerAction('skip-viral-penalty', () => { (window as any).skipViralPenalty?.(); });
registerAction('skip-viral-invite', () => { (window as any).skipViralInvite?.(); });
registerAction('share-to-story', () => { (window as any).shareToStory?.(); });
registerAction('share-viral-invite', () => { (window as any).shareViralInvite?.(); });
registerAction('tod-choice', (el) => { (window as any).handleTodChoice?.(el.dataset.choice); });
registerAction('nhie-toggle-player', (el) => { (window as any).toggleNhiePlayer?.(el.dataset.playerId); });
registerAction('wyr-vote', (el) => { (window as any).wyrVote?.(el.dataset.choice); });
registerAction('next-text-card', () => { (window as any).nextTextGameCard?.(); });
registerAction('mlt-count-start', () => { (window as any).startMltCountdown?.(); });
registerAction('reveal-timer-word', () => { (window as any).revealTimerWord?.(); });
registerAction('trn-timer-judgement', (el) => { (window as any).trnTimerJudgement?.(el.dataset.result === 'true'); });
registerAction('timer-game-finish', () => { (window as any).timerGameFinish?.(); });
registerAction('timer-game-ready', () => { (window as any).timerGameReady?.(); });
registerAction('timer-game-next', () => { (window as any).timerGameNext?.(); });
registerAction('reveal-emoji-word', () => { (window as any).revealEmojiWord?.(); });
registerAction('trn-emoji-judgement', (el) => { (window as any).trnEmojiJudgement?.(el.dataset.result === 'true'); });
registerAction('clear-emoji-input', () => { (window as any).clearEmojiInput?.(); });
registerAction('emoji-guessed', () => { (window as any).emojiGuessed?.(); });
registerAction('connection-retry', () => { document.getElementById('connection-error-overlay')?.remove(); (window as any).__connectionRetry?.(); });

registerInputAction('update-player-name', (el) => { (window as any).updatePlayerName?.((el as HTMLInputElement).dataset.playerId, (el as HTMLInputElement).value); });
registerInputAction('trn-rename-team', (el) => { (window as any).trnRenameTeam?.((el as HTMLInputElement).dataset.teamId, (el as HTMLInputElement).value); });
registerInputAction('trn-update-player-name', (el) => { (window as any).updatePlayerName?.((el as HTMLInputElement).dataset.playerId, (el as HTMLInputElement).value); (window as any).__trnPlayerNameSync?.(); });
registerInputAction('trn-set-punishment', (el) => { (window as any).trnSetPunishment?.((el as HTMLTextAreaElement).value); });

// ─── Telegram viewport height fix ────────────────────────────────────
// На мобильном Telegram 100vh ≠ реальная высота окна.
// Синхронизируем CSS-переменную с фактической высотой из SDK.
function syncViewportHeight() {
  const tg = (window as any).Telegram?.WebApp;
  const h = tg?.viewportStableHeight
    ? `${tg.viewportStableHeight}px`
    : `${window.innerHeight}px`;
  document.documentElement.style.setProperty('--tg-viewport-stable-height', h);
}
syncViewportHeight();
try {
  (window as any).Telegram?.WebApp?.onEvent?.('viewportChanged', syncViewportHeight);
} catch (_) {}

// Global app state for simple routing
let currentScreen = 'home';
let authErrorScreen = false;
// Lock — prevents two concurrent init() calls from executing simultaneously.
let _initRunning = false;

function renderAuthError() {
  ensureI18nLang();
  const app = document.querySelector<HTMLDivElement>('#app')!;
  app.innerHTML = `
    <div class="w-full max-w-[430px] h-screen mx-auto relative overflow-hidden bg-void flex flex-col items-center justify-center p-8 text-center">
      <div class="text-[64px] mb-4">🔐</div>
      <div class="font-display text-[24px] font-extrabold text-white mb-2">${t('session_expired_title')}</div>
      <div class="text-t-secondary text-[15px] font-semibold mb-8">${t('session_expired_text')}</div>
      <button
        data-action="tg-close"
        class="w-full py-[17px] px-[24px] bg-grad-primary rounded-pill text-white font-body text-[17px] font-extrabold shadow-glow-primary"
      >
        ${t('session_expired_btn')}
      </button>
    </div>
  `;
}

function showBannedScreen(reason: string, lang?: string) {
  ensureI18nLang(lang);
  const safeReason = reason.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
  const app = document.querySelector<HTMLDivElement>('#app')!;
  app.innerHTML = `
    <div class="w-full max-w-[430px] h-screen mx-auto bg-void flex flex-col items-center justify-center p-8 text-center">
      <div class="text-[72px] mb-4">🚫</div>
      <div class="font-display text-[26px] font-extrabold text-white mb-3">
        ${t('banned_title')}
      </div>
      <div class="text-t-secondary text-[14px] font-semibold mb-4 leading-relaxed">
        ${t('banned_text')}
      </div>
      <div class="bg-glass border border-white/10 rounded-[18px] p-[16px] mb-8 w-full">
        <div class="text-[11px] font-extrabold text-t-muted tracking-[1px] mb-[6px]">${t('banned_reason_label')}</div>
        <div class="text-[14px] text-white font-semibold">${safeReason}</div>
      </div>
      <div class="text-[13px] text-t-muted font-semibold">
        ${t('banned_contact')}
      </div>
      <button
        data-action="tg-close"
        class="mt-8 w-full py-[15px] px-[24px] bg-glass border border-white/10 rounded-pill text-white font-body text-[16px] font-bold"
      >
        ${t('banned_close_btn')}
      </button>
    </div>
  `;
}

function renderApp() {
  const app = document.querySelector<HTMLDivElement>('#app')!;
  
  // Decide which screen content to show
  let content = '';
  if (currentScreen === 'home') {
    content = renderHome();
  } else if (currentScreen === 'games') {
    content = renderLevelSelect();
  } else if (currentScreen === 'game-setup') {
    content = renderGameSetup();
  } else if (currentScreen === 'text-game') {
    content = renderTextGameEngine();
  } else if (currentScreen === 'timer-game') {
    content = renderTimerGameEngine();
  } else if (currentScreen === 'emoji-game') {
    content = renderEmojiGameEngine();
  } else if (currentScreen === 'premium') {
    content = renderPremium();
  } else if (currentScreen === 'invite') {
    content = renderInvite();
  } else if (currentScreen === 'profile') {
    content = renderProfile();
  } else if (currentScreen === 'tournament-setup') {
    content = renderTournamentSetup();
  } else if (currentScreen === 'tournament-board') {
    content = renderTournamentBoard();
  } else if (currentScreen === 'tournament-victory') {
    content = renderTournamentVictory();
  } else {
    // Placeholder screen
    content = `
      <div class="absolute inset-0 overflow-y-auto overflow-x-hidden pb-[96px] z-10 scrollbar-none bg-transparent flex flex-col items-center justify-center p-6">
        <div class="text-[64px] mb-4 drop-shadow-[0_0_12px_rgba(255,255,255,0.2)]">🚧</div>
        <div class="font-display text-2xl font-extrabold text-t-primary mb-2 text-center">In Development</div>
        <div class="text-t-secondary text-center text-sm">
          Screen "<span class="text-neon-pink font-bold">${currentScreen}</span>" will be here soon.
        </div>
      </div>
    `;
  }

  app.innerHTML = `
    <!-- App Shell base styles -->
    <div class="w-full max-w-[430px] h-screen mx-auto relative overflow-hidden bg-void">
      <!-- Background glares -->
      <div class="fixed inset-0 pointer-events-none z-0">
        <div class="absolute -top-[20%] -left-[10%] w-[70%] h-[60%] bg-[radial-gradient(ellipse,rgba(160,32,240,0.12)_0%,transparent_70%)]"></div>
        <div class="absolute -bottom-[10%] -right-[15%] w-[60%] h-[50%] bg-[radial-gradient(ellipse,rgba(255,45,107,0.10)_0%,transparent_70%)]"></div>
      </div>
      
      <!-- Current Screen Content -->
      ${content}
      
      <!-- Bottom Navbar -->
      ${!['text-game','timer-game','emoji-game','tournament-setup','tournament-board','tournament-victory'].includes(currentScreen) ? NavBar(currentScreen) : ''}
    </div>
  `;

  // Attach event listeners for Bottom Nav items
  const navItems = app.querySelectorAll<HTMLDivElement>('[data-nav]');
  navItems.forEach(item => {
    item.addEventListener('click', (e) => {
      const targetScreen = (e.currentTarget as HTMLDivElement).dataset.nav;
      if (targetScreen) {
        window.navTo(targetScreen);
      }
    });
  });

  // Attach delegated emoji grid listener after render
  if (currentScreen === 'emoji-game') {
    setupEmojiGridListener();
  }
  if (currentScreen === 'games') {
    setupLevelSelectListener();
  }
  if (currentScreen === 'home') {
    setupHomeListener();
  }

  setupBackButton(currentScreen, window.navTo);
}

// ─── Toast Notification ─────────────────────────────────────────────

function showToast(message: string, type: 'error' | 'success' | 'info' = 'error', durationMs = 3000) {
  const existing = document.getElementById('app-toast');
  if (existing) existing.remove();

  const toast = document.createElement('div');
  toast.id = 'app-toast';
  toast.textContent = message;

  const bgClass = type === 'success'
    ? 'bg-emerald-500/90'
    : type === 'info'
      ? 'bg-blue-500/90'
      : 'bg-red-500/90';
  toast.className = `fixed top-[60px] left-1/2 z-[9999] ${bgClass} text-white px-6 py-3 rounded-2xl text-sm font-bold backdrop-blur-md shadow-lg pointer-events-none`;
  toast.style.transform = 'translateX(-50%) translateY(-20px)';
  toast.style.opacity = '0';
  toast.style.transition = 'all 0.3s ease';

  document.body.appendChild(toast);

  requestAnimationFrame(() => {
    toast.style.opacity = '1';
    toast.style.transform = 'translateX(-50%) translateY(0)';
  });

  setTimeout(() => {
    toast.style.opacity = '0';
    toast.style.transform = 'translateX(-50%) translateY(-20px)';
    setTimeout(() => toast.remove(), 300);
  }, durationMs);
}

// ─── Global declarations ────────────────────────────────────────────

declare global {
  interface Window {
    navTo: (screenId: string) => void;
    renderApp: () => void;
    navToPremiumCoins: () => void;
    showToast: (message: string, type?: 'error' | 'success' | 'info', durationMs?: number) => void;
    __reinit: () => Promise<void>;
    __showBannedScreen: (reason: string, lang?: string) => void;
    __showSessionExpired: () => void;
    showLangPicker: () => void;
    setLang: (lang: string) => Promise<void>;
  }
}

// Guard: never overwrite error/ban/session screens with a normal app render.
window.renderApp = () => {
  if (!authErrorScreen) renderApp();
};
window.showToast = showToast;

cardsManager.setNotificationHandler((newLevel) => {
  const labels: Record<string, string> = {
    easy: t('difficulty_easy'),
    medium: t('difficulty_medium'),
    hard: t('difficulty_hard'),
    all: t('difficulty_all'),
  };
  const label = labels[newLevel || 'all'] || t('difficulty_all');
  showToast(t('difficulty_expanded').replace('{level}', label), 'info', 4000);
});
window.__showBannedScreen = (reason: string, lang?: string) => {
  authErrorScreen = true;
  haltAllRequests('banned');  // kill switch на уровне API
  showBannedScreen(reason, lang);
};
window.__showSessionExpired = () => {
  if (authErrorScreen) return;
  authErrorScreen = true;
  haltAllRequests('session');  // kill switch на уровне API
  renderAuthError();
};

window.navToPremiumCoins = () => {
  window.navTo('premium');
  setTimeout(() => {
    const el = document.getElementById('screen-premium');
    if (el) el.scrollTo({ top: el.scrollHeight, behavior: 'smooth' });
  }, 50);
};

window.navTo = (screenId: string) => {
  if (authErrorScreen) return; // Banned or session expired — block all navigation.
  if (screenId === 'invite') (window as any).__markInviteNeedsRefresh?.();
  if (screenId === 'tournament-setup' && currentScreen !== 'tournament-setup') {
    resetTournamentSetupState();
  }

  if (screenId !== 'home') {
    window.history.pushState({ screen: screenId }, '', `#${screenId}`);
  } else {
    window.history.pushState({ screen: 'home' }, '', window.location.pathname + window.location.search);
  }

  const GAME_SCREENS = ['text-game', 'timer-game', 'emoji-game', 'tournament-setup', 'tournament-board', 'tournament-victory'];

  // Cleanup при уходе с game-экранов
  if (currentScreen === 'text-game') cleanupTextGame();
  if (currentScreen === 'timer-game') cleanupTimerGame();
  if (currentScreen === 'emoji-game') cleanupEmojiGame();

  // Wake Lock: включить на игровых экранах, выключить на остальных
  if (GAME_SCREENS.includes(screenId)) {
    (window as any).__gameScreenActive = true;
    requestWakeLock();
  } else if (GAME_SCREENS.includes(currentScreen)) {
    (window as any).__gameScreenActive = false;
    releaseWakeLock();
  }

  if (currentScreen !== screenId) {
    currentScreen = screenId;
    renderApp();
  }
};

window.addEventListener('popstate', () => {
  if (currentScreen !== 'home') {
    window.history.pushState(null, '', window.location.href);
    window.navTo('home');
  }
});

// --- Auth & init ---
async function init() {
  // ── Kill switch: если приложение в terminal-состоянии, немедленно отказ ──
  if (isTerminal()) {
    const err = new Error('terminal') as any;
    err.status = 0;
    throw err;
  }

  // ── Concurrency lock: prevent two simultaneous init() calls ──
  if (_initRunning) {
    const err = new Error('init already running') as any;
    err.status = 0;
    throw err;
  }
  _initRunning = true;

  // НЕ сбрасываем authErrorScreen здесь.
  // Он будет сброшен в false ТОЛЬКО после полного успеха auth ниже.

  // Показать лоадер ТОЛЬКО если нет экрана ошибки
  const app = document.querySelector<HTMLDivElement>('#app');
  if (app && state.isLoading && !authErrorScreen) {
    app.innerHTML = `
      <div class="w-full max-w-[430px] h-screen mx-auto bg-void flex items-center justify-center">
        <div class="text-center">
          <div class="text-[48px] animate-pulse mb-4">🎮</div>
          <div class="text-t-secondary text-[14px] font-semibold">Loading...</div>
        </div>
      </div>
    `;
  }

  try {
    const tgInitData = (window as any).Telegram?.WebApp?.initData || '';
    if (!tgInitData) {
      throw new Error('No Telegram initData found. Please launch from Telegram.');
    }

    const authRes = await api.auth(tgInitData);
    setToken(authRes.token);
    state.user = authRes.user;
    ensureI18nLang(authRes.user.lang);

    const [savedDifficulty, initRes] = await Promise.all([
      loadDifficulty(),
      api.getInit().catch(() => null),
    ]);
    if (initRes) {
      state.games = initRes.games;
      state.user = initRes.user;
    }
    state.difficultyRange = savedDifficulty;

    // Restore active tournament if exists.
    const restored = tryRestoreActive();
    if (restored && state.tournament) {
      if (state.tournament.status === 'finished') {
        currentScreen = 'tournament-victory';
      } else if (state.tournament.status !== 'lobby') {
        state.tournament.status = 'lobby';
        currentScreen = 'tournament-board';
      } else {
        currentScreen = 'tournament-board';
      }
    }

    // ✅ Auth полностью успешен — проверяем, не обнаружил ли параллельный init бан
    // пока мы ждали ответа от сервера.
    if (isTerminal()) {
      // A concurrent init detected terminal state — abort this one immediately.
      throw new Error('terminal');
    }
    // Разрешаем рендер
    authErrorScreen = false;
  } catch (e: any) {
    console.error('Auth failed', e);
    authErrorScreen = true;
    haltAllRequests();  // Kill switch: ГАРАНТИЯ что больше ни один запрос не пройдёт

    if (e?.message === 'banned') {
      // Ban screen already shown by __showBannedScreen inside client.ts.
      throw e;
    }
    if (e?.status === 429) {
      showToast(t('error_rate_limit') || 'Too many requests — please wait a minute', 'error');
      renderAuthError();
      throw e;
    }
    renderAuthError();
    throw e;
  } finally {
    _initRunning = false;
    state.isLoading = false;
    if (!authErrorScreen) {
      renderApp();
      try { (window as any).Telegram?.WebApp?.ready?.(); } catch (_) {}
    }
  }
}

// Expose init for re-authentication on 401.
// Errors are intentionally re-thrown inside init() so that request()
// enters its catch(reinitErr) path and stops retrying.
window.__reinit = async () => {
  if (isTerminal()) {
    const err = new Error('terminal') as any;
    err.status = 0;
    throw err;
  }
  if (_initRunning) {
    const err = new Error('init already running') as any;
    err.status = 0;
    throw err;
  }
  return init();
};

// Initial bootstrap — swallow the throw here since screens are already rendered.
init().catch(() => {});

// ─── Session healthcheck on app resume ──────────────────────────────
// Проверяем живость сессии только при возврате из бэкграунда.
// Если токен протух — api.request() сам вызовет __showSessionExpired.
let _lastHealthcheck = 0;
document.addEventListener('visibilitychange', async () => {
  if (document.visibilityState === 'visible' && state.user && !authErrorScreen && !isTerminal()) {
    if (Date.now() - _lastHealthcheck < 60_000) return;
    _lastHealthcheck = Date.now();
    try {
      const fresh = await api.getUser();
      if (
        fresh.is_premium !== state.user.is_premium ||
        fresh.premium_expires_at !== state.user.premium_expires_at
      ) {
        await (window as any).__reinit?.();
        return;
      }
      state.user = fresh;
    } catch (_) {
      // 401/403/429 уже обработаны внутри api.request()
    }
  }
});
